import { requests } from ".";
import { SERVICE_NAME } from "@/config/serviceNames";
import { EntityType, Module } from "@/constants";

export enum SortOrder {
  asc = "asc",
  desc = "desc",
}

const buildQueryParams = (params?: Record<string, unknown>) => {
  if (!params) {
    return "";
  }

  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null) {
      return;
    }
    if (Array.isArray(value)) {
      value.forEach((entry) => {
        if (entry !== undefined && entry !== null) {
          searchParams.append(key, String(entry));
        }
      });
      return;
    }

    searchParams.append(key, String(value));
  });

  const queryString = searchParams.toString();
  return queryString ? `?${queryString}` : "";
};

const MarketplaceService = {
  getMarketplaceAppRatings: (query?: any) =>
    requests(SERVICE_NAME.MARKETPLACE_API).get(`app/review/support${buildQueryParams(query)}`),

  processReviewComment: (id: string, data?: any) =>
    requests(SERVICE_NAME.MARKETPLACE_API)
      .log({
        module: Module.MARKETPLACE_APP_SUPPORT,
        entityType: EntityType.OTHERS,
        entityId: id,
      })
      .post(`app/review/support/${id}`, data),

  async getApps(params: { sortByInstallations?: "true" | "false"; sortOrder?: SortOrder }) {
    const url = `/api/marketplace/apps${buildQueryParams(params)}`;
    return await requests(SERVICE_NAME.MARKETPLACE_API).get(url);
  },

  Review: {
    getAppsForReview: (query?: any) =>
      requests(SERVICE_NAME.MARKETPLACE_API).get(`app/review${buildQueryParams(query)}`),

    getReviewedApps: (query?: any) =>
      requests(SERVICE_NAME.MARKETPLACE_API).get(`app/review/live${buildQueryParams(query)}`),

    getModules: (query?: any) =>
      requests(SERVICE_NAME.MARKETPLACE_API).get(`app/review/modules${buildQueryParams(query)}`),

    getAppModules: (appId: string, query?: any) =>
      requests(SERVICE_NAME.MARKETPLACE_API).get(
        `app/review/${appId}/modules${buildQueryParams(query)}`
      ),

    getActivityLogs: (id: string, query?: any) =>
      requests(SERVICE_NAME.MARKETPLACE_API).get(
        `app/review/${id}/comments${buildQueryParams(query)}`
      ),

    createReview: (id: string, versionId: string, data?: any) =>
      requests(SERVICE_NAME.MARKETPLACE_API)
        .log({
          module: Module.MARKETPLACE_APP_SUPPORT,
          entityType: EntityType.OTHERS,
          entityId: id,
          documentId: versionId,
        })
        .post(`app/review/${id}/versions/${versionId}`, data),

    getScriptsForReview: (query?: any) =>
      requests(SERVICE_NAME.MARKETPLACE_API).get(
        `app/review/custom-script${buildQueryParams(query)}`
      ),

    getScriptActivityLogs: (query?: any) =>
      requests(SERVICE_NAME.MARKETPLACE_API).get(
        `app/review/item-comments${buildQueryParams(query)}`
      ),

    createScriptReview: (customJSId: string, data?: any) =>
      requests(SERVICE_NAME.MARKETPLACE_API)
        .log({
          module: Module.MARKETPLACE_APP_SUPPORT,
          entityType: EntityType.OTHERS,
          entityId: customJSId,
        })
        .post(`app/review/custom-script/${customJSId}`, data),

    updateWhiteLabelStatus: (id: string, payload: any) =>
      requests(SERVICE_NAME.MARKETPLACE_API)
        .log({
          module: Module.MARKETPLACE_APP_SUPPORT,
          entityType: EntityType.OTHERS,
          entityId: id,
        })
        .post(`app/review/${id}/whitelabelstatus`, payload),
  },
};

export default MarketplaceService;
